import {useState, ChangeEvent, useEffect, KeyboardEvent } from 'react';
import { TextField } from '@mui/material';
import { RoadFeatures, RoadFeaturesWithBruksklasse} from '../../../services/RuteplanAPI';

interface IRoadFeatureApiTextFieldProps {
  isRequest: boolean,
  roadFeatureRequest: string,
  setRoadFeatureRequest: (value: string) => void;
  roadFeatureResponse?: RoadFeatures | RoadFeaturesWithBruksklasse | undefined,
  onMouseEnterTextArea: () => void;
  onMouseLeaveTextArea: () => void;
}

export default function RoadFeatureApiTextField(props: IRoadFeatureApiTextFieldProps) {
  const [input, setInput] = useState<string>(props.roadFeatureRequest);
  const [parsable, setParsable] = useState(true);

  const onTabDown = (event: KeyboardEvent<HTMLDivElement>) => {

    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();

      const target = event.target as HTMLInputElement | HTMLTextAreaElement;
      const start = target.selectionStart || 0;
      const end = target.selectionEnd || 0;

      const newValue = input.substring(0, start) + '\t' + input.substring(end);
      setInput(newValue);

      setTimeout(() => {
        target.selectionStart = target.selectionEnd = start + 1;
      }, 0);
    }

    if(event.key === 'Tab' && event.shiftKey) {
      event.preventDefault();
      const target = event.target as HTMLInputElement | HTMLTextAreaElement;
      const start = target.selectionStart || 0;
      const end = target.selectionEnd || 0;

      const newValue = input.substring(0, start).replace('\t', "") + input.substring(end);
      setInput(newValue);

      setTimeout(() => {
        target.selectionStart = target.selectionEnd = start - 1;
      }, 0);
    }
  };

  useEffect(() => {
      let parsed;
      try {
      parsed = JSON.parse(input);
      setParsable(true);
      props.setRoadFeatureRequest(JSON.stringify(parsed, null, 4));
    } catch {
      setParsable(false);
    }
    }, [input]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.target.value);
  }

    return (
    <>
    { props.isRequest ?      
        <TextField
            error={!parsable}
            helperText={!parsable ? "Error parsing JSON" : ""}
            onChange={handleChange}
            onKeyDown={onTabDown}
            multiline
            fullWidth
            minRows='2'
            value={input}
            onMouseEnter={props.onMouseEnterTextArea}
            onMouseLeave={props.onMouseLeaveTextArea}
            style={{ 
              height: '99%',
              overflowY: 'auto'
            }}
            />
            :  
        <TextField
            multiline
            contentEditable={false}
            fullWidth
            minRows='2'
            value={JSON.stringify(props.roadFeatureResponse, null, 4)}
            onMouseEnter={props.onMouseEnterTextArea}
            onMouseLeave={props.onMouseLeaveTextArea}
            style={{ 
              height: '99%',
              overflowY: 'auto'
            }}
            />
      }
    </>
    
    );

}


